module.exports = __webpack_public_path__ + "img/dekouple.48a01499.png";